import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { User as UserModel } from "../../../models/user";
import * as UserApi from "../../../network/user_api";
import * as LeaderboardApi from "../../../network/leaderboard_api";
import * as CollectiblesdApi from "../../../network/collectibles_api";
import Profile from "./Profile";
import { useTranslation } from "react-i18next";
import Divider from "../../../components/Decors/Divider/Divider";
import { CardTheme } from "../../../models/cardThemes";
import { ProfileImage } from "../../../models/profileImages";
import { SplashScreen } from "../../../models/splashScreens";

const ProfileLoggedInView = () => {
  const [user, setUser] = useState<UserModel>();
  const [rank, setRank] = useState<number>(0);
  const [badgeCount, setBadgeCount] = useState<number>(0);
  const [profileImages, setProfileImages] = useState<ProfileImage[]>([]);
  const [splashScreens, setSplashScreens] = useState<SplashScreen[]>([]);
  const [cardThemes, setCardThemes] = useState<CardTheme[]>([]);
  const [userLoading, setUserLoading] = useState(true);
  const [showUserLoadingError, setShowUserLoadingError] = useState(false);

  useEffect(() => {
    async function loadUser() {
      try {
        setShowUserLoadingError(false);
        setUserLoading(true);
        const user = await UserApi.fetchUser();
        setUser(user);
      } catch (error) {
        console.error(error);
        alert(error);
        setShowUserLoadingError(true);
      } finally {
        setUserLoading(false);
      }
    }
    loadUser();
  }, []);

  useEffect(() => {
    async function loadUser() {
      try {
        setShowUserLoadingError(false);
        setUserLoading(true);
        const rank = await LeaderboardApi.fetchUserRank();
        setRank(rank);
      } catch (error) {
        console.error(error);
        alert(error);
        setShowUserLoadingError(true);
      } finally {
        setUserLoading(false);
      }
    }
    loadUser();
  }, []);

  useEffect(() => {
    async function loadProfileImages() {
      try {
        const profileImages = await CollectiblesdApi.fetchProfileImages();
        setProfileImages(profileImages);
      } catch (error) {
        console.error("Failed to fetch profile images:", error);
      }
    }
    loadProfileImages();
  }, []);

  useEffect(() => {
    async function loadSplashScreens() {
      try {
        const splashScreens = await CollectiblesdApi.fetchSplashScreens();
        setSplashScreens(splashScreens);
      } catch (error) {
        console.error("Failed to fetch card splash shreens:", error);
      }
    }
    loadSplashScreens();
  }, []);

  useEffect(() => {
    async function loadCardThemes() {
      try {
        const themes = await CollectiblesdApi.fetchCardThemes();
        setCardThemes(themes);
      } catch (error) {
        console.error("Failed to fetch card themes:", error);
      }
    }
    loadCardThemes();
  }, []);

  useEffect(() => {
    async function loadBadgeCount() {
      try {
        const count = await CollectiblesdApi.fetchBadgeCount();
        setBadgeCount(count);
      } catch (error) {
        console.error("Failed to fetch badge count:", error);
      }
    }
    loadBadgeCount();
  }, []);

  const { t } = useTranslation();

  return (
    <div>
      <div className="title-block-container">
        <h1>{t("pages.profile")}</h1>
        <Divider />
      </div>
      {userLoading && <Spinner className="custom-spinner" animation="border" />}
      {showUserLoadingError && <p>{t("error.refresh")}</p>}
      {!userLoading && !showUserLoadingError && (
        <>
          {user && (
            <Profile
              user={user}
              rank={rank}
              badgeCount={badgeCount}
              collectibleCount={
                profileImages.length + splashScreens.length + cardThemes.length
              }
              profileImages={profileImages}
              splashScreens={splashScreens}
              cardThemes={cardThemes}
              onProfileSaved={(user) => {
                setUser(user);
              }}
            />
          )}
        </>
      )}
    </div>
  );
};

export default ProfileLoggedInView;
